import { useStore } from 'hooks/useStore';
import { useState } from 'react';
// import { toJS } from "mobx";

export const useTMSViewTable = () => {
  const [directCOT, setDirectCOT] = useState<{
    label: string;
    value: string;
  }>({ label: 'CMOP', value: 'cmop' });
  const [indirectCOT, setindirectCOT] = useState<{
    label: string;
    value: string;
  }>({ label: 'CMOP', value: 'cmop' });

  const {
    MSPlanStore: {
      isTMSPlanViewDataLoading,
      isMSplanPlanningPeriodLoading,
      tmsViewData,
      conceptDetails,
      isConceptLoading,
      isTMSNotesDataLoading,
      tmsNotesData,
      msplanPlanningPeriod,
      msplanPeriod,
      setMSplanPlaningPeriod,
    },
  } = useStore();

  // get future 12 months date
  const getFutureMonths = () => {
    const arr: { label: string; dateString: string }[] = [];
    const [year, month, _day] = msplanPeriod.code.split('-');
    const startMonth = Number(month);
    const startYear = Number(year);
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i) % 12;
      const year = startYear + Math.floor((startMonth + i) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
      });
    }

    return arr;
  };

  const tmsPlanningMonth: { label: string; dateString: string }[] = getFutureMonths();

  const handleOptionChange = (option: { label: string; code: string }) => {
    setMSplanPlaningPeriod(option);
  };

  const getValues = (cot: string, cat: string, planningDate: string, need: string) => {
    if (tmsViewData.GFC === 0) return '-';

    const cotPlan = tmsViewData.tms_adjustment_data.filter(
      item => item.COT.toLowerCase() === cot.toLowerCase()
    )[0];

    const catCOTPlan = cotPlan?.SellingCategories.filter(
      item => item.SellingCategory.toLowerCase() === cat.toLowerCase()
    )[0];

    const tmsDataCurrent = catCOTPlan?.tms_adjustment_details.filter(
      item => item.TMSPlanningMonth === planningDate
    );

    // Check for previous month data if current month data is not available
    const previousMonth = new Date(planningDate);
    let tmsDataPrevious: {
      TMSPlanningMonth: string;
      TMSStrategyCode: string;
      TargetMarketShare: number;
      Adjustment: number;
      MarketSharePlan: number;
    }[] = [];
    const maxIterations = 12;
    let iteration = 0;
    let isPrevFound = false;
    while (!isPrevFound && iteration < maxIterations) {
      previousMonth.setMonth(previousMonth.getMonth() - 1);
      const previousPlanningDate = previousMonth.toISOString().split('T')[0];
      const [year, month, _day] = previousPlanningDate.split('-');
      tmsDataPrevious = catCOTPlan?.tms_adjustment_details.filter(
        item => item.TMSPlanningMonth === `${year}-${month}-01`
      );
      if (tmsDataPrevious && tmsDataPrevious.length !== 0) {
        isPrevFound = true;
      }
      iteration++;
    }

    const tmsData = tmsDataCurrent && tmsDataCurrent.length > 0 ? tmsDataCurrent : tmsDataPrevious;

    if (tmsData && tmsData.length === 0) {
      return '-';
    } else {
      if (need === 'stratcode' && tmsData) {
        return tmsData[0]?.TMSStrategyCode;
      } else if (need === 'tmsval' && tmsData) {
        return String(Math.ceil(Number(tmsData[0]?.TargetMarketShare) * 100)) + '%';
      } else if (need === 'msplan' && tmsData) {
        return String(Math.ceil(Number(tmsData[0]?.MarketSharePlan) * 100)) + '%';
      } else {
        return '-';
      }
    }
  };

  return {
    directCOT,
    setDirectCOT,
    indirectCOT,
    setindirectCOT,
    conceptDetails,
    isConceptLoading,
    tmsPlanningMonth,
    isTMSPlanViewDataLoading,
    isMSplanPlanningPeriodLoading,
    isTMSNotesDataLoading,
    tmsNotesData,
    msplanPlanningPeriod,
    msplanPeriod,
    getValues,
    handleOptionChange,
  };
};
